import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import ScrollToTop from "./components/scrolltotop/ScrollToTop";
import Error from "./pages/innerpages/Error";

// Import Css Here
import "./assets/scss/style.scss";
import LandingPage from "./pages/LandingPage";
import RedirectPage from "./pages/RedirectPage";
import KYouthContactUs from "./pages/innerpages/KYouthContactUs";

function App() {
  return (
    <Router>
      <ScrollToTop>
        <Routes>
          <Route exact path="/" element={<RedirectPage />} />
          <Route exact path="/k-youth" element={<LandingPage />} />
          <Route exact path="/contact-us" element={<KYouthContactUs />} />
          <Route path="*" element={<Error />} />
        </Routes>
      </ScrollToTop>
    </Router>
  );
}

export default App;
